import React from 'react';
import { connect } from 'react-redux';
import ZoomControl from 'components/common/zoom-control-component';
import {
  incrementZoom,
  decrementZoom,
  leftIncrementZoom,
  leftDecrementZoom,
  rightIncrementZoom,
  rightDecrementZoom,
} from 'store/actions/zoom-actions';
import {
  setContentFixedMode,
  setContentFullMode,
} from 'store/actions/content-view-modes-actions';
import { setContainerScrollTop } from 'store/actions/container-scroll-top-actions';
import { LEFT_VIEW_DOCUMENT_ID, RIGHT_VIEW_DOCUMENT_ID } from 'constants/feature/statement-content-constants';

export const ZoomControlHOC = (props) => {
  const {
    zoom,
    leftZoom,
    leftDecrementZoom,
    leftIncrementZoom,
    incrementZoom,
    decrementZoom,
    isLeftSideView,
    isSideBySidePage,
    rightIncrementZoom,
    rightDecrementZoom,
    setContainerScrollTop,
    rightZoom,
    selectedStatement,
    leftSelectedStatement,
  } = props;
  const selectedStatementData = isLeftSideView
    ? leftSelectedStatement
    : selectedStatement;
  const { isOCR } = selectedStatementData;
  const zoomValue = isSideBySidePage
    ? isLeftSideView
      ? leftZoom
      : rightZoom
    : zoom;
  const containerId = isLeftSideView
    ? LEFT_VIEW_DOCUMENT_ID
    : RIGHT_VIEW_DOCUMENT_ID;

  const setContainerScrollTopValue = () => {
    const container = document.getElementById(containerId);
    if (!container) return null;
    const currentScrollTop = container.scrollTop;
    setContainerScrollTop(currentScrollTop);
  };

  const onPlus = () => {
    if (isOCR) {
      setContainerScrollTopValue();
    }

    isSideBySidePage
      ? isLeftSideView
        ? leftIncrementZoom()
        : rightIncrementZoom()
      : incrementZoom();
  };

  const onMinus = () => {
    if (isOCR) {
      setContainerScrollTopValue();
    }

    isSideBySidePage
      ? isLeftSideView
        ? leftDecrementZoom()
        : rightDecrementZoom()
      : decrementZoom();
  };
  return (
    <ZoomControl
      {...props}
      zoomModel={zoomValue}
      onPlus={onPlus}
      onMinus={onMinus}
    />
  );
};

const areEqual = (prevProps, nextProps) => {
  const prevKeys = Object.keys(prevProps);
  const nextKeys = Object.keys(nextProps);

  if (prevKeys.length !== nextKeys.length) {
    return false;
  }

  // Check each property for shallow equality
  return prevKeys.every((key) => {
    const prevValue = prevProps[key];
    const nextValue = nextProps[key];

    if (
      prevValue &&
      nextValue &&
      typeof prevValue === 'object' &&
      typeof nextValue === 'object'
    ) {
      if (Array.isArray(prevValue) && Array.isArray(nextValue)) {
        return (
          prevValue.length === nextValue.length &&
          prevValue.every((item, index) => item === nextValue[index])
        );
      }

      if (prevValue === nextValue) return true;

      const prevObjKeys = Object.keys(prevValue);
      const nextObjKeys = Object.keys(nextValue);

      if (prevObjKeys.length !== nextObjKeys.length) {
        return false;
      }

      return prevObjKeys.every(
        (objKey) => prevValue[objKey] === nextValue[objKey],
      );
    }

    return prevValue === nextValue;
  });
};

const MemoizedZoomControlHOC = React.memo(ZoomControlHOC, areEqual);

const mapStateToProps = ({
  data: {
    selectedStatement,
    leftSelectedStatement,
  },
  ui: {
    statementPage: {
      zoom,
      leftZoom,
      rightZoom,
      modes: { contentViewMode },
    },
  },
}) => ({
  contentViewMode,
  zoom,
  leftZoom,
  rightZoom,
  selectedStatement,
  leftSelectedStatement,
});

const mapDispatchToProps = {
  setContentFixedMode,
  setContentFullMode,
  leftIncrementZoom,
  leftDecrementZoom,
  incrementZoom,
  decrementZoom,
  rightIncrementZoom,
  rightDecrementZoom,
  setContainerScrollTop,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MemoizedZoomControlHOC);
